import React, { useState, useEffect } from "react";
import { api } from "../../api";
import { Icon, Spinner } from "../../components/ui";

const locCode = (l) => { const m = String(l || "").match(/\(([^)]+)\)/); return m ? m[1] : String(l || "").trim(); };

function LocationTable({ data }) {
  if (!data) return <div className="sum-none">No snapshot yet — available from tomorrow.</div>;
  const { locations = [], rows = [], colTotals = {}, grandTotal = 0, grandIssue = 0 } = data;
  return (
    <div className="sum-scroll">
      <table className="tbl sum-tbl">
        <thead><tr>
          <th className="sum-rowhead">RTC status</th>
          {locations.map((l) => <th key={l} className="sum-num" title={l}>{locCode(l)}</th>)}
          <th className="sum-num sum-total-col">Total</th>
          <th className="sum-num sum-issue-col">Issue</th>
        </tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.bucket}>
              <td className="sum-rowhead">{r.bucket}</td>
              {locations.map((l) => <td key={l} className="sum-num">{(r.cells?.[l] || 0) || <span className="sum-zero">·</span>}</td>)}
              <td className="sum-num sum-total-col">{r.total || 0}</td>
              <td className="sum-num sum-issue-col">{r.issue ? r.issue : <span className="sum-zero">·</span>}</td>
            </tr>
          ))}
          <tr className="sum-total-row">
            <td className="sum-rowhead">Total</td>
            {locations.map((l) => <td key={l} className="sum-num">{colTotals[l] || 0}</td>)}
            <td className="sum-num sum-total-col">{grandTotal}</td>
            <td className="sum-num sum-issue-col">{grandIssue}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

function StatTable({ data }) {
  if (!data) return null;
  const { rows = [], grandNonStat = 0, grandStat = 0, grandTotal = 0 } = data;
  return (
    <div className="sum-scroll" style={{ marginTop: 12 }}>
      <table className="tbl sum-tbl">
        <thead><tr>
          <th className="sum-rowhead">RTC status</th>
          <th className="sum-num">Non-STAT</th><th className="sum-num">STAT</th><th className="sum-num sum-total-col">Total</th>
        </tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.bucket}>
              <td className="sum-rowhead">{r.bucket}</td>
              <td className="sum-num">{r.nonStat || <span className="sum-zero">·</span>}</td>
              <td className="sum-num">{r.stat || <span className="sum-zero">·</span>}</td>
              <td className="sum-num sum-total-col">{r.total || 0}</td>
            </tr>
          ))}
          <tr className="sum-total-row">
            <td className="sum-rowhead">Total</td>
            <td className="sum-num">{grandNonStat}</td><td className="sum-num">{grandStat}</td><td className="sum-num sum-total-col">{grandTotal}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

function Panel({ title, keyLabel, summary }) {
  return (
    <div className="sum-panel">
      <div className="sum-panel-head"><b>{title}</b>{keyLabel && <span className="sum-panel-date">{keyLabel}</span>}</div>
      <div className="sum-sec-label">RTC age × Clinic location</div>
      <LocationTable data={summary?.locationTable} />
      {summary?.statTable && <><div className="sum-sec-label" style={{ marginTop: 14 }}>RTC age × STAT</div><StatTable data={summary.statTable} /></>}
    </div>
  );
}

export function Summary() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.summary().then(setData).catch((e) => setErr(e.message)); }, []);
  if (err) return <div className="err-text" style={{ padding: 18 }}>{err}</div>;
  if (!data) return <div className="empty"><Spinner /></div>;
  const fmt = (k) => { try { const [y, m, d] = k.split("-"); return `${m}/${d}/${y}`; } catch { return k; } };
  return (
    <div className="jr-page">
      <div style={{ marginBottom: 12 }}>
        <h2 style={{ margin: 0 }}>Summary</h2>
        <div className="cell-sub">Records by RTC age and location (and STAT). Today on the left, yesterday's frozen snapshot on the right for comparison. “Issue” = records flagged Client / Patient / Production.</div>
      </div>
      <div className="sum-compare">
        <Panel title="Today" keyLabel={fmt(data.todayKey)} summary={data.today} />
        <Panel title="Yesterday" keyLabel={data.yesterday ? fmt(data.yesterdayKey) : ""} summary={data.yesterday} />
      </div>
    </div>
  );
}